const addressEditLangCN = {
    addressAdministration:"地址管理",
    default:"默认",
    addAddress:"添加地址"
}


const addressEditLangEN = {
    addressAdministration:"Address administration",
    default:"Default",
    addAddress:"Add the address"
}

const langPackage = {
    cn:addressEditLangCN,
    en:addressEditLangEN
}


export {langPackage}
